import {prepareOrder} from './amp-lazy-tool.js';
import {sendRequest} from "./tools/ajax_es.js";

export function monitoringTableSort()
{
    const tables = document.getElementsByClassName('monitoring-products-table');

    initFlyerMiniatures();

    if(!tables)
    {
        return
    }

    const buttons = document.getElementsByClassName('next-button-products');

    Array.prototype.forEach.call(tables, function(table) {
        const sort = table.getElementsByClassName('psort');
        const contents = table.getElementsByClassName('next-data-ph');

        if (contents.length > 0) {
            let content = contents[0];
            let link = content.getAttribute('data-link');
            let button = null;

            if (buttons.length > 0 && contents.length > 0) {
                button = buttons[0];
            }
            for (var i = 0; i < sort.length; i++) {
                let sortButton = sort[i];
                sortButton.addEventListener('click', () => {
                    if (button) {
                        button.style.display = 'inline-block';
                        content.setAttribute('data-page', 1);
                    }
                    tableSort(sortButton, link, content, table);
                });
            }
        }
    });
}

const onProductImageClick = (miniaturesWrapperElement) => {
    const image = miniaturesWrapperElement.querySelector('.product-detail');

    if (!image) return;
    miniaturesWrapperElement.classList.toggle('show-image')

    if (!image.getBoundingClientRect) return;
    const imageDimensions = image.getBoundingClientRect();

    if (image.classList.contains('product-detail--show-bottom') && imageDimensions.top + imageDimensions.height > window.innerHeight) {
        image.classList.remove('product-detail--show-bottom');
        image.classList.add('product-detail--show-top');
    } else if (image.classList.contains('product-detail--show-top') && imageDimensions.bottom + imageDimensions.height < window.innerHeight) {
        image.classList.remove('product-detail--show-top');
        image.classList.add('product-detail--show-bottom');
    }
}

const initProductImageCloseButtons = (miniaturesWrapperElements) => {
    for (let i = 0; i < miniaturesWrapperElements.length; i++) {
        const miniaturesWrapperElement = miniaturesWrapperElements[i];
        const closeProductImageElement = miniaturesWrapperElement.querySelector('.product-detail-close');

        if (!closeProductImageElement) return;
        
        closeProductImageElement.addEventListener('click', function(event) {
            miniaturesWrapperElement.classList.remove('show-image');
        });
    }
}

export const initFlyerMiniatures = () => {
    const miniaturesWrapperElements = document.getElementsByClassName('snapchat');

    if (miniaturesWrapperElements && miniaturesWrapperElements.length > 0) {
        // amp does not have getBoundingClientRect function
        const isAmp = !!!miniaturesWrapperElements[0].getBoundingClientRect;

        initProductImageCloseButtons(miniaturesWrapperElements);

        // on AMP we cannot check outside element click => only toggle image on click miniature
        if (isAmp) {
            for (let i = 0; i < miniaturesWrapperElements.length; i++) {
                const miniaturesWrapperElement = miniaturesWrapperElements[i];

                miniaturesWrapperElement.onclick = function(event) {
                    const isClickOnCloseBtn = event.target && event.target.classList.contains('product-detail-close');
                    if (!isClickOnCloseBtn) {
                        onProductImageClick(miniaturesWrapperElement);
                    }
                };
            }
        } else {
            document.onclick = function(event) {

                for (let i = 0; i < miniaturesWrapperElements.length; i++) {
                    const miniaturesWrapperElement = miniaturesWrapperElements[i];

                    const isProductImageShown = miniaturesWrapperElement.classList.contains('show-image');
                    const isClickOnMiniature = miniaturesWrapperElement.contains(event.target);

                    if (isClickOnMiniature) {
                        const isClickOnCloseBtn = event.target && event.target.classList.contains('product-detail-close');

                        if (!isClickOnCloseBtn) {
                            onProductImageClick(miniaturesWrapperElement);
                        }
                    } else if (!isClickOnMiniature && isProductImageShown) {
                        miniaturesWrapperElement.classList.remove('show-image') 
                    }
                }
            };
        }
    }
}

function tableSort(sortButton, link, content, table) {

    let order = prepareOrder(sortButton, true);
    let column = sortButton.getAttribute('data-col');

    handleButtonSortBehaviour(sortButton, order);

    populateOrderData(content, column, order);
    sortButton.setAttribute('data-order', order);

    link = link.replace(/-order=[asc|desc]+/, "-order=" + order);
    link = link.replace(/-column=[0|a-z]+/, "-column=" + column);
    link = link.replace(/-page=\d+/, "-page=0");

    if (content.hasAttribute('data-archive') === true) {
        let archive = content.getAttribute('data-archive');
        link = link.replace(/-archive=\d+/, "-archive=" + archive);
    }

    sendRequest(link, function (xmlhttp) {
        const snippetResponse = xmlhttp.response;
        const snippets = snippetResponse.snippets;

        for (var i in snippets) {
            const data = snippets[i];

            if(table.tFoot)
            {
                table.tFoot.innerHTML = '';
            }
            if(table.tBodies.length > 0 )
            {
                // to rozdeleni na tbody a tfoot je kvuli amp inicializaci obrazku - zahazovaly se
                // proto razeni dame do body, dalsi nacitanni produktu pujde zase do tfoot
                table.tBodies[0].innerHTML = data;

                // Po implementaci skeleton loaderu musíme resetovat data ze stránkování z 2. tbody.
                table.tBodies[1].innerHTML = '';
            }
            break;
        }
    });
}

function populateOrderData(content, column, order)
{
    if(order)
    {
        content.setAttribute('data-order', order);
    }

    if(column)
    {
        content.setAttribute('data-col', column);
    }
}

/**
 * Handlení chování tlačítka, kde je šipka.
 * @param cell Buňka/nadpis sloupce.
 * @param order ASC/DESC.
 */
function handleButtonSortBehaviour(cell, order) {
    let button = cell.getElementsByClassName('monitoring-sort-button')[0];
    let arrow = button.getElementsByTagName('i')[0];

    // Všem tlačítkům přidám classu, pokud ji nemají.
    document.querySelectorAll('.page-arrow').forEach((arrow) => {
        arrow.classList.add('inactive');
    });

    // A pouze z tlačítka, na které teď uživatel klikl, uděláme ze šedivého růžové.
    arrow.classList.remove('inactive');

    // Podle řazení zobrazíme šipku.
    if (order === 'asc') {
        // ASC = up
        arrow.classList.replace('down', 'up');
    } else if (order === 'desc') {
        // DESC = down
        arrow.classList.replace('up', 'down');
    }
}